<template>
  <div>
    <div class="modal fade" tabindex="-1" :class="{ show: showModal }">
      <div class="modal-dialog">
        <div class="modal-content">
          <addTemplateModal
            v-if="showAddTemplateModal == true"
            @close-add-template-modal="showAddTemplateModal = false"
          />
          <addDonationModal :selectedDonation="selectedDonation"
            v-if="showAddDonationModal == true" :selectedScreen="screen" :selectedArtboard="selectedArtboard" :imageWidth="imageWidth" :imageHeight="imageHeight"
            @close-add-donation-modal="showAddDonationModal = false"
            @refresh-screen="getScreens()"
          />
          <!-- <div class="modal-header">
            <h6 class="modal-title">Add Donation</h6>
            <div class="dropdown dropright">
              <div
                class="dropdown-toggle"
                type="button"
                data-toggle="dropdown"
                id="dropdownMenuButton1"
              >
                Screen Using <i class="pi pi-chevron-down"></i>
              </div>
              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                <template v-bind:key="index" v-for="(screenOption, index) in screens">
                  <li v-on:click="screen = screenOption">{{ screenOption.name }}</li>
                </template>
              </div>
            </div>
            <button
              type="button"
              class="btn btn-light"
              style="float: right; padding-bottom: 0px"
              @click="closeModal()"
              aria-label="Close"
            >
              <i class="pi pi-times"></i>
            </button>
          </div> -->
          <Form class="form" @submit="addDonation">
            <div class="modal-body">
              <div class="row">
                <div class="col-10">
                  <div v-if="screen">
                    <div v-if="screen.image" class="image-container" ref="containerRef">
                      <img :src="getScreenImage(screen.image)" class="col-12 display-img" ref="imageEl"  @load="onImageLoad"/>
                  
                      <template :key="artboard.id" v-for="artboard in screen.artboards">
                        <div
                          class="artboard-wrapper"
                          :style="getArtboardStyle(artboard)"
                        >
                          <div class="dropdown-container">
                            <div class="dropdown">
                              <button
                                v-on:click="selectAddDonationModal(artboard)"
                                class="col-12 btn btn-custom-primary dropdown-toggle"
                                type="button"
                                data-toggle="dropdown"
                              >
                                <div class="row justify-content-between align-items-center">
                                  <span><i class="pi pi-plus"></i> New Donation</span>
                                  <!-- <span><i class="pi pi-ellipsis-h"></i></span> -->
                                </div> 
                              </button>
                              <!-- <div class="dropdown-menu">
                                <a v-on:click="selectAddDonationModal(artboard)" class="dropdown-item">Add Donation</a>
                                <a class="dropdown-item" href="#">Add Announcement</a>
                              </div> -->
                            </div>
                
                          </div>
                          <div class="artboard-box-inner">
                            <div v-if="artboard.donations[0]" v-html="renderContent(artboard.donations[0]?.template?.content, artboard.donations[0])"></div>
                          </div>
                        </div>
                
                      </template>
                    </div>
                  </div>
                </div>
                <div v-if="screen" class="col-2 scrollable-section">
                  <template v-for="(screenOption, index) in screens" v-bind:key="index">
                    <div v-on:click="screen = screenOption" :class="[ screenOption.id == screen.id ? 'selected-screen-card' : '', 'card screen-card']">
                      <img class="card-img-top" :src="getScreenImage(screenOption.image)" alt="Card image cap">
                      <div class="card-body">
                        <p class="title text-center">{{ screenOption.name }}</p>
                        <!-- <p class="donations text-center">Donations: 21</p> -->
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <!-- <button
                type="submit"
                class="btn btn-custom-primary"
                :disabled="donationIsLoading ? true : false"
              >
                <span
                  v-if="donationIsLoading"
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                <span v-if="!donationIsLoading">Save</span>
              </button> -->
              <button type="button" class="btn btn-custom-secondary" @click="closeModal()">
                Close
              </button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import templatesModal from '@/components/template/Templates_Modal.vue';
import addTemplateModal from '@/components/template/Add_Template_Modal.vue';
import addDonationModal from '@/components/donation/Register_Donation_Modal.vue';
import { SCREEN_IMAGES_DIR, STORAGE_URL } from '@/utils/const'

import { Field, Form, ErrorMessage, defineRule } from 'vee-validate';
import { GET_SCREENS, GET_TEMPLATES, REGISTER_DONATION } from '@/store/action_types';

defineRule('required', (value, [fieldName = 'Field']) => {
  if (!value || value.length === 0) {
    return `${fieldName} is required`;
  }
  return true;
});
defineRule('alpha', (value, [fieldName = 'Field']) => {
  const alphaRegExp = /^[a-zA-Z]*$/;
  return (
    alphaRegExp.test(value) ||
    `${fieldName} must contain only alphabetic characters`
  );
});

export default {
  props: {
    selectedArtboard: {
      type: Object,
      required: true
    },
    imageWidth: {
      type: String,
      required: true
    },
    imageHeight: {
      type: String,
      required: true
    },
    selectedDonation: {
      type: Object,
      required: false
    }
  },
  components: {
    Field,
    Form,
    ErrorMessage,
    templatesModal,
    addTemplateModal,
    addDonationModal
  },
  data() {
    return {
      showModal: true,
      imageWidth: 1,
      imageHeight: 1,
      imageReady: false,
      showAddTemplateModal: false,
      showAddDonationModal: false,
      selectedArtboard: null,
      showTemplatesModal: false,
      screen: null,
      addDonationObj: {
        title: null,
        name: null,
        inHonorOf: null,
        offset: null,
        screenId: null,
        screenArtboardId: null,
        templateId: null,
        organizationId: null,
      },
    };
  },
  watch: {
    screen: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.imageReady = false;
          this.$nextTick(() => {
            this.onImageLoad();
          });
        }
      } 
    }
  },
  computed: {
    screens() {
      return this.$store.getters.screens.data;
    },
    screensIsLoading() {
      return this.$store.getters.screens.isLoading;
    },
    donation() {
      return this.$store.getters.donation.data;
    },
    donationIsLoading() {
      return this.$store.getters.donation.isLoading;
    },
    templates() {
      return this.$store.getters.templates.data;
    },
    templatesIsLoading() {
      return this.$store.getters.templates.isLoading;
    },
    account() {
      return this.$store.getters.account.data;
    },
  },
  methods: {
    setValues() {
      // this.addDonationObj.screenArtboardId = this.selectedArtboard.id;
      // this.addDonationObj.screenId = this.$route.params.id;
      // this.addDonationObj.organizationId = this.account.organizationId;

      const offsetMinutes = -new Date().getTimezoneOffset();
      this.addDonationObj.offset = offsetMinutes;
    },
    closeModal() {
      this.$emit('closeAddDonationModal');
    },
    onImageLoad() {
      this.imageEl = this.$refs.imageEl;
        this.imageWidth = this.imageEl.clientWidth;
        this.imageHeight = this.imageEl.clientHeight;
        this.imageReady = true;
    },
    selectAddDonationModal(artboard) {
      this.selectedArtboard = artboard
      this.showAddDonationModal = true
    },
    renderContent(template, donation) {
      let replacements = []

      Object.keys(donation).forEach(key => { 
        console.log('key', key)
          const regex = new RegExp(`{${key}}`, 'g');
          if (template.includes(`{${key}}`)) {
              replacements.push({
                  replace: regex,
                  replaceBy: key == 'title' ? `${donation['title']}`
                            : key == 'name' ? `${donation['name']}` 
                            : key == 'donationDate' ? `${this.$filters.getDateOnly(donation.createdAt)}` 
                            : key == 'displayStartDate' ? `${this.$filters.getDateOnly(donation.displayStartDate)}` 
                            : key == 'displayEndDate' ? `${this.$filters.getDateOnly(donation.displayEndDate)}` 
                            : donation[key]
              })
          }

      });

      replacements.forEach((e) => {
          template = template.replace(e.replace, e.replaceBy)
      })
      return template;
    },
    getScreenImage(image) {
      return `${STORAGE_URL}/${SCREEN_IMAGES_DIR}/${image}`;
    },
    emitGetScreen() {
      this.$emit('refreshScreen');
    },
    getDropdownStyle(artboard) {
      return {
        position: 'absolute',
        top: artboard.topPercent * this.imageHeight * 1.1 + 'px',
        left: artboard.leftPercent * this.imageWidth + 'px',
        width: artboard.widthPercent * this.imageWidth + 'px',
        height: artboard.heightPercent * this.imageHeight + 'px',
        border: '1px dashed #2ecc71',
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        overflow: 'auto'
      };
    },
    getArtboardStyle(artboard) {
      return {
        position: 'absolute',
        top: artboard.topPercent * this.imageHeight + 'px',
        left: artboard.leftPercent * this.imageWidth + 'px',
        width: artboard.widthPercent * this.imageWidth + 'px',
        height: artboard.heightPercent * this.imageHeight + 'px',
        border: '1px dashed #2ecc71',
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        overflow: 'auto'
      };
    },
    getTemplates() {
      this.$store.dispatch(GET_TEMPLATES, { organizationId: this.account.organizationId })
    },
    getScreens() {
      this.$store.dispatch(GET_SCREENS, { organizationId: this.account.organizationId }).then((res) => {
        if(res) {
          this.screen = this.screens[0]
        }
      })
    },
    addDonation() {
      this.$store
        .dispatch(REGISTER_DONATION, this.addDonationObj)
        .then((res) => {
          if (res) {
            this.closeModal();
            this.$emit('refreshScreen');
          }
        });
    },
  },
  mounted() {
    this.setValues();
    this.getTemplates()
    this.getScreens()
  },
};
</script>

<style scoped>
.screen-card {
  padding: 0px;
  box-shadow: none;
}

.screen-card .pi:hover {
  cursor: pointer;
}

.screen-card .card-body {
  padding: 10px;
}

.screen-card .card-body .title {
  font-weight: 500;
  font-size: 0.7rem;
  cursor: pointer;
  margin-bottom: 0px;
  color: #1D1F2C;
}

.screen-card .card-body .donations {
  font-size: 12px;
  margin-bottom: 7px;
}

.screen-card .card-body .badge-container {
  display: grid;
  place-items: center;
}

.screen-card .card-body .pi {
  margin-left: 10px;
  color: #007bff;
  font-size: 13px;
}

.card .card-loading {
  opacity: 1;
}

.card-overlay i {
  font-size: 2rem;
  color: #fff;
}

.modal-content {
  border-radius: 20px !important;
  border: 1px solid transparent;
  background-color: #fdfdfe !important;
  height: 96vh;
  overflow-x: hidden;
  overflow-y: auto;
}

.scrollable-section {
  max-height: 90vh; /* Set the maximum height for the scrollable area */
  overflow-y: auto; /* Enable vertical scrolling */
  margin-top: 13px;
}

.selected-screen-card {
  border: 1px solid var(--color-primary);
  box-shadow: 0 0 3px #8AA3DFFF; /* Add a glow effect */
  transition: box-shadow 0.3s ease-in-out;
}

.screen-card:hover {
  cursor: pointer;
  border: 1px solid var(--color-primary);
  box-shadow: 0 0 3px #8AA3DFFF; /* Add a glow effect */
  transition: box-shadow 0.3s ease-in-out;
}

.modal {
  display: none;
}

.modal.show {
  display: block;
}

.modal-dialog {
  max-width: 50%;
  margin-top: 15px;
  margin-bottom: 10px;
}

.modal {
  background-color: rgba(0, 0, 0, 0.1);
  z-index: 1000;
}

.modal-content {
  border: 1px solid #e4e4e7;
}

.modal-header {
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  border-bottom: 1px solid #e4e4e7;
}

.modal-header .modal-title {
  position: relative;
  top: 8px;
  font-size: 1.1rem;
}

.image-container {
  position: relative;
  display: inline-block;
  margin-top: 1rem;
}

.artboard-box {
  box-sizing: border-box;
}

.image-container {
  position: relative;
  display: inline-block;
  margin-top: 1rem;
}

.artboard-box {
  box-sizing: border-box;
}

.btn-custom-primary {
  padding: 0.5rem 1.6rem 0.5rem 1.6rem;
}

.btn-custom-primary .pi-ellipsis-h {
  font-size: 0.9rem;
}

.artboard-wrapper {
  position: absolute;
  border: 1px dashed #2ecc71;
  background-color: rgba(255, 255, 255, 0.8);
  padding-top: 42px;
  overflow: visible !important;
  z-index: 2;
}

.dropdown-container {
  position: absolute;
  top: -43px;
  left: 0;
  right: 0;
  z-index: 3;
}

.artboard-box-inner {
  overflow: auto;
  height: 100%;
}

.modal-footer {
  border-top: 1px solid #e4e4e7;
}

@media (min-width: 1000px) {
  .modal-dialog {
    max-width: 95%;
  }
}
</style>
